// HQ tooling (cross-tenant user provisioning) is only exposed on the
// PIRM HQ portal itself, never on customer/tenant domains.
import { HQ_HOSTNAMES } from "./hosts";

export function isHqPortal() {
  return HQ_HOSTNAMES.includes(window.location.hostname);
}
